<template>
  <b-form-input
      id="input-1"
      v-model="prop.value"
      :disabled="prop.readonly"
      type="text"
  ></b-form-input>
</template>
<script>
export default {
  name: 'TextInput',
  props: {
    prop: {}
  }
}
</script>



// WEBPACK FOOTER //
// src/components/editor/TextInput.vue